import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Login from "../screens/Login";
import LoginTest from "../screens/LoginTest";
function AuthRoutes() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<LoginTest />}>
          {/* Default route to dashboard */}
          <Route index element={<LoginTest />} />
        </Route>
      </Routes>
    </Router>
  );
}
export default AuthRoutes;
